<mat-dialog-content class="">
  <h3 class="mb-3"><i class="fas fa-check-circle mr-1"></i> View Details</h3>
  <div class="row">
    <div class="col-md-8 col-sm-12">
      <div class="row">
        <div class="col-md-6 col-sm-12 pl-0">
          <label class="mb-0">License Plate:</label>
          <p>{{ citationData.lpn }}</p>
        </div>
        <div class="col-md-6 col-sm-12 pl-0">
          <label class="mb-0">Permit ID:</label>
          <p>{{ citationData.permitId }}</p>
        </div>
        <div class="col-md-6 col-sm-12 pl-0">
          <label class="mb-0">Status:</label>
          <p>{{ citationData.citationStatus }}</p>
        </div>
        <div class="col-md-6 col-sm-12 pl-0">
          <label class="mb-0">Citation Amount:</label>
          <p>{{ citationData.fineAmount }}</p>
        </div>
        <div class="col-md-6 col-sm-12 pl-0">
          <label class="mb-0">Reason:</label>
          <p>{{ citationData.systemAutomatedReason }}</p>
        </div>
        <div class="col-md-6 col-sm-12 pl-0">
          <label class="mb-0">Boot Tow:</label>
          <p>{{ citationData.carBootTow }}</p>
        </div>
        <div class="col-md-6 col-sm-12 pl-0">
          <label class="mb-0">Comment:</label>
          <p>{{ citationData.comment }}</p>
        </div>
        <div class="col-md-6 col-sm-12 pl-0">
          <label class="mb-0">Citation Time:</label>
          <p>{{ citationData.citationTime | date : "y-MM-dd HH:mm:ss" }}</p>
        </div>
        <div class="col-md-6 col-sm-12 pl-0">
          <label class="mb-0">Created By:</label>
          <p>{{ citationData.createdBy | date : "y-MM-dd HH:mm:ss" }}</p>
        </div>
        <div class="col-md-6 col-sm-12 pl-0">
          <label class="mb-0">Created Date:</label>
          <p>{{ citationData.createdDate | date : "y-MM-dd HH:mm:ss" }}</p>
        </div>
      </div>
    </div>
    <div class="col-md-4 col-sm-12">
      <div class="row">
        <div class="col-md-12 col-sm-12 pl-0 pb-2">
          <label class="mb-0">Full Image:</label>
          <img
            src="{{ citationData.fullImageUrl }}"
            alt="Full Image"
            class="citationImg d-block"
          />
        </div>
        <div class="col-md-12 col-sm-12 pl-0">
          <label class="mb-0">Cropped Image:</label>
          <img
            src="{{ citationData.croppedImageUrl }}"
            alt="Cropped Image"
            class="citationImg d-block"
          />
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button class="btn btn-danger float-right" (click)="closeDialog()">
    <i class="fas fa-times mr-1"></i> Close
  </button>
</mat-dialog-actions>
